import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
  const items = ["Graphic Design", "Climate Action", "Creative Writing"];
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div
				style={{
					height: 2921,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 89,
					}}>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						<div
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
					</div>
					<span
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Learners"}
					</span>
					<div
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 41,
						}}>
						<span
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 35,
							}} >
							{"Explore all learners"}
						</span>
					</div>
					<div
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 17,
							}}>
							<span
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Interest-Based Matching"}
							</span>
							<div
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 16,
									paddingRight: 204,
									marginBottom: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xhy41ew0_expires_30_days.png"}
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search interest..."}
									value={input3}
									onChange={(event) => onChangeInput3(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 109,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Entrepreneurship"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Technology & Coding"}
									</span>
								</button>
							</div>
							{/* <div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Graphic Design"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Climate Action"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Creative Writing"}
									</span>
								</button>
							</div> */}
							<Box
								sx={{
									display: "flex",
									alignItems: "flex-start",
									mb: 1.5,
									gap: 1.5, // equals 12px by default MUI spacing
								}}
							>
								{items.map((item, index) => (
									<Button
										key={index}
										onClick={() => alert(`${item} pressed!`)}
										variant="outlined"
										sx={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											textAlign: "left",
											backgroundColor: "#FFFFFF",
											borderRadius: "6px",
											border: "1px solid #E6E6E6",
											py: 1, // paddingTop and paddingBottom (8px)
											px: 1.5, // paddingLeft and paddingRight (12px)
											textTransform: "none",
											"&:hover": {
												backgroundColor: "#F9F9F9",
												borderColor: "#00AEEF",
											},
										}}
									>
										<Typography
											sx={{
												color: "#2C2C2C",
												fontSize: 12,
												fontWeight: "bold",
											}}
										>
											{item}
										</Typography>
									</Button>
								))}
							</Box>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Mental Health Awareness"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Community Development"}
									</span>
								</button>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Mathematics & Logic"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E7F1F880",
										borderRadius: 6,
										border: `1px solid #1074BC`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 8,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#1074BC",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"AI & Machine Learning"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mknsn6uu_expires_30_days.png"}
										style={{
											borderRadius: 6,
											width: 9,
											height: 9,
											objectFit: "fill",
										}}
									/>
								</button>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Women in Tech"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Sustainable Living"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Social Justice"}
									</span>
								</button>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E7F1F880",
										borderRadius: 6,
										border: `1px solid #1074BC`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 9,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#1074BC",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Education for All"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dbqtu7ex_expires_30_days.png"}
										style={{
											borderRadius: 6,
											width: 9,
											height: 9,
											objectFit: "fill",
										}}
									/>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Mobile App Development"}
									</span>
								</button>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Financial Literacy"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E7F1F880",
										borderRadius: 6,
										border: `1px solid #1074BC`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 9,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#1074BC",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Robotics & Engineering"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v4ky08o4_expires_30_days.png"}
										style={{
											borderRadius: 6,
											width: 9,
											height: 9,
											objectFit: "fill",
										}}
									/>
								</button>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Language Learning"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Digital Marketing"}
									</span>
								</button>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									gap: 12,
								}}>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"Gaming & Game Design"}
									</span>
								</button>
								<button
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#E6F7FD",
										borderRadius: 6,
										border: `1px solid #00AEEF`,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										textAlign: "left",
									}}
									onClick={() => alert("Pressed!")}>
									<span
										style={{
											color: "#00AEEF",
											fontSize: 12,
											fontWeight: "bold",
										}} >
										{"See more"}
									</span>
								</button>
							</div>
						</div>
						<div
							style={{
								width: 1,
								height: 1146,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Discover Learners"}
							</span>
							<div
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>

							<div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										marginRight: 16,
										gap: 16,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k2rj38hc_expires_30_days.png"}
										style={{
											width: 90,
											height: 116,
											objectFit: "fill",
										}}
									/>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 10,
										}}>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "#979797",
												borderRadius: 2,
												paddingTop: 1,
												paddingBottom: 1,
												paddingLeft: 6,
												paddingRight: 6,
											}}>
											<span
												style={{
													color: "#FFFFFF",
													fontSize: 9,
													fontWeight: "bold",
												}} >
												{"Offline"}
											</span>
										</div>
										<div
											style={{
												display: "flex",
												alignItems: "center",
											}}>
											<span
												style={{
													color: "#010101",
													fontSize: 16,
													fontWeight: "bold",
													marginRight: 110,
												}} >
												{"Jane Cooper"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/h5bnwqm7_expires_30_days.png"}
												style={{
													width: 17,
													height: 17,
													objectFit: "fill",
												}}
											/>
										</div>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cd7lc4no_expires_30_days.png"}
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<span
											style={{
												color: "#6C6C6C",
												fontSize: 10,
												width: 210,
											}} >
											{"Bio: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas porttitor nulla vitae viverra ornare..."}
										</span>
									</div>
								</div>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										marginRight: 16,
										gap: 12,
									}}>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 6,
											border: `1px solid #00000000`,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 36,
											paddingRight: 38,
											gap: 2,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/c978cv2d_expires_30_days.png"}
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#00AEEF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"View Profile"}
										</span>
									</div>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 27,
											paddingRight: 29,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7vhykmrb_expires_30_days.png"}
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Send Message"}
										</span>
									</div>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										marginRight: 16,
										gap: 16,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ffygi9ns_expires_30_days.png"}
										style={{
											width: 90,
											height: 116,
											objectFit: "fill",
										}}
									/>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 10,
										}}>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "#0BBB0D",
												borderRadius: 2,
												paddingTop: 1,
												paddingBottom: 1,
												paddingLeft: 6,
												paddingRight: 6,
											}}>
											<span
												style={{
													color: "#FFFFFF",
													fontSize: 9,
													fontWeight: "bold",
												}} >
												{"Available"}
											</span>
										</div>
										<div
											style={{
												display: "flex",
												alignItems: "center",
											}}>
											<span
												style={{
													color: "#010101",
													fontSize: 16,
													fontWeight: "bold",
													marginRight: 111,
												}} >
												{"Jacob Jones"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vlti6w7a_expires_30_days.png"}
												style={{
													width: 17,
													height: 17,
													objectFit: "fill",
												}}
											/>
										</div>
										<div
											style={{
												display: "flex",
												alignItems: "center",
												gap: 6,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/r5ivx91r_expires_30_days.png"}
												style={{
													width: 8,
													height: 10,
													objectFit: "fill",
												}}
											/>
											<span
												style={{
													color: "#2C2C2C",
													fontSize: 10,
												}} >
												{"New York City, USA"}
											</span>
										</div>
										<span
											style={{
												color: "#6C6C6C",
												fontSize: 10,
												width: 210,
											}} >
											{"Bio: Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas porttitor nulla vitae viverra ornare..."}
										</span>
									</div>
								</div>
								<div
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										marginRight: 16,
										gap: 12,
									}}>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 6,
											border: `1px solid #00000000`,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 36,
											paddingRight: 38,
											gap: 2,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q1idtw2g_expires_30_days.png"}
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#00AEEF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"View Profile"}
										</span>
									</div>
									<div
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 27,
											paddingRight: 29,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/edt7ow7n_expires_30_days.png"}
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Send Message"}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div
							style={{
								width: 1,
								height: 1146,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 15,
								}}>
								<span
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 137,
									}} >
									{"Browse Filters"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0q81lc76_expires_30_days.png"}
									style={{
										width: 10,
										height: 10,
										objectFit: "fill",
									}}
								/>
							</div>
							<div
								style={{
									width: 277,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 103,
									}} >
									{"Business Strategy"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 111,
									}} >
									{"Digital Marketing"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 79,
									}} >
									{"Product Development"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
									gap: 56,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
									}} >
									{"Fundraising & Investment"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 135,
									}} >
									{"UX/UI Design"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									width: 277,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 28,
								}}>
							</div>
							<span
								style={{
									color: "#010101",
									fontSize: 18,
									fontWeight: "bold",
									marginBottom: 20,
									marginLeft: 20,
								}} >
								{"Availability"}
							</span>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 163,
									}} >
									{"Available"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 190,
									}} >
									{"Busy"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 178,
									}} >
									{"Offline"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									width: 277,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 28,
								}}>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginRight: 132,
									}} >
									{"Locations"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wirg75u7_expires_30_days.png"}
									style={{
										width: 22,
										height: 22,
										objectFit: "fill",
									}}
								/>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#00AEEF",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 121,
									}} >
									{"New York, USA"}
								</span>
								<div
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 5,
										padding: 1,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3l8cyqp0_expires_30_days.png"}
										style={{
											width: 15,
											height: 15,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 145,
									}} >
									{"London, UK"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 118,
									}} >
									{"Berlin, Germany"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 155,
									}} >
									{"Singapore"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 28,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 108,
									}} >
									{"Sydney, Australia"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									width: 277,
									height: 6,
									background: "#F1F2F4",
									marginBottom: 28,
								}}>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 20,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginRight: 122,
									}} >
									{"Languages"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pk1kpds8_expires_30_days.png"}
									style={{
										width: 22,
										height: 22,
										objectFit: "fill",
									}}
								/>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 175,
									}} >
									{"English"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 170,
									}} >
									{"Spanish"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 177,
									}} >
									{"French"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 161,
									}} >
									{"Mandarin"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 24,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 170,
									}} >
									{"German"}
								</span>
								<div
									style={{
										width: 17,
										height: 17,
										background: "#FFFFFF",
										borderRadius: 5,
										border: `1px solid #979797`,
									}}>
								</div>
							</div>
							<button
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #00000000`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 110,
									paddingRight: 110,
									marginBottom: 10,
									textAlign: "left",
								}}
								onClick={() => alert("Pressed!")}>
								<span
									style={{
										color: "#6BD0F6",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Clear"}
								</span>
							</button>
							<button
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 107,
									paddingRight: 107,
									textAlign: "left",
								}}
								onClick={() => alert("Pressed!")}>
								<span
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Apply"}
								</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}